import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import { gsap } from "gsap";

export class MapOxxoTeam2TopicThree extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			const model = gltf.scene;

			this.Cafetera_3 = gltf.scene.getObjectByName("Cafetera_3", true);
			this.Cafetera_1 = gltf.scene.getObjectByName("Cafetera_1", true);
			this.Cafe_ = gltf.scene.getObjectByName("Cafe_", true);
			this.Cafe_2 = gltf.scene.getObjectByName("Cafe_2", true);
			this.Cafetera_2 = gltf.scene.getObjectByName("Cafetera_2", true);
			this.Cafe_1 = gltf.scene.getObjectByName("Cafe_1", true);
			this.Cafetera_Krea = gltf.scene.getObjectByName("Cafetera_Krea", true);
			this.Vasos = gltf.scene.getObjectByName("Vasos", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			// model.traverse((node) => {
			// 	if (node.isMesh) {
			// 		const material = node.material;
			// 		material.transparent = true; // Permite la transparencia
			// 		material.opacity = 0.1; // Establece la opacidad (0.5 para 50% de opacidad)
			// 	}
			// });

			this.add(model);
		});
	}

	onVisibleCafetera1(value = false) {
		this.Cafetera_1.visible = value;
	}

	onVisibleCafetera_Krea(value = false) {
		this.Cafetera_Krea.visible = value;
	}

	onVisibleYelox(value = false) {
		this.Yelox.visible = value;
	}

	onVisibleAnotherPart1() {
		this.Cafetera_3.visible = false
		// this.Cafe_.visible = false;
		// this.Cafe_2.visible = false;
		// this.Cafetera_2.visible = false;
		// this.Cafe_1.visible = false;
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
			this.animation = null
			this.Vasos.material.emissiveIntensity = 1
		}
	}
	onAnimate(object) {
		if (this.animation) {
			this.animation.kill();
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;
		object.material.emissiveIntensity = 1;

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	eliminateAnimation(object) {
		if (this.animation) {
			this.animation.kill();
		}
		object.material.emissiveIntensity = 0;
	}

	renderAnimations() { }
}
